// Swiper Class
import {Swiper, Navigation, Pagination, Thumbs, Controller, Autoplay} from 'swiper';

Swiper.use([Navigation, Pagination, Thumbs, Controller, Autoplay])

//EXPORT
export default Swiper;
